import React from "react";
import { Box } from "@mui/material";
import { pdfRectToCanvasRect } from "../../../../../../../utils/coordinateUtils";

const PdfTextOverlayLayer = ({
  currentProcessingFile,
  pageNumber,
  selectToolActive,
  highlightFields,
  setCurrentProcessingFile,
  textSelectionMode,
}) => {
  const currentDocument =
    currentProcessingFile?.document?.tempFields?.currentDocument || {};
  const viewport = currentDocument?.viewport || null;
  const pageHeight = currentDocument?.actualHeight || 792;

  const textItems =
    currentProcessingFile?.document?.tempFields?.pdfTextItemsByPage?.[
      pageNumber
    ] || [];
  const selectedTextItem =
    currentProcessingFile?.document?.tempFields?.selectedPdfTextItem || null;
  const selectedExtraPdfTextItems =
    currentProcessingFile?.document?.tempFields?.selectedExtraPdfTextItems ||
    [];
  const pdfTextEdits =
    currentProcessingFile?.document?.tempFields?.pdfTextEdits || [];

  return (
    <>
      {textItems.map((item) => {
        const rect = pdfRectToCanvasRect(item.rect, viewport || pageHeight, 1);
        const isSelected =
          selectedTextItem?.id === item.id ||
          selectedExtraPdfTextItems.some(
            (selected) => selected?.id === item.id,
          );
        const existingEdit = pdfTextEdits.find(
          (edit) => edit.target_item_id === item.id,
        );

        return (
          <React.Fragment key={item.id}>
            <Box
              onMouseDown={(e) => {
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (!selectToolActive || !textSelectionMode) return;

                setCurrentProcessingFile((prev) => ({
                  ...prev,
                  document: {
                    ...prev.document,
                    tempFields: (() => {
                      const tempFields = prev.document.tempFields;
                      const primary = tempFields.selectedPdfTextItem;
                      const extras = tempFields.selectedExtraPdfTextItems || [];
                      const isModifierPressed = e.ctrlKey || e.metaKey;

                      if (!isModifierPressed) {
                        return {
                          ...tempFields,
                          selectedFormField: null,
                          selectedExtraFields: [],
                          selectedPdfTextItem: item,
                          selectedExtraPdfTextItems: [],
                        };
                      }

                      if (!primary) {
                        return {
                          ...tempFields,
                          selectedFormField: null,
                          selectedExtraFields: [],
                          selectedPdfTextItem: item,
                          selectedExtraPdfTextItems: [],
                        };
                      }

                      if (primary.id === item.id) {
                        const [nextPrimary = null, ...rest] = extras;
                        return {
                          ...tempFields,
                          selectedFormField: null,
                          selectedExtraFields: [],
                          selectedPdfTextItem: nextPrimary,
                          selectedExtraPdfTextItems: rest,
                        };
                      }

                      const alreadyExtra = extras.some(
                        (selected) => selected?.id === item.id,
                      );

                      return {
                        ...tempFields,
                        selectedFormField: null,
                        selectedExtraFields: [],
                        selectedPdfTextItem: primary,
                        selectedExtraPdfTextItems: alreadyExtra
                          ? extras.filter(
                              (selected) => selected?.id !== item.id,
                            )
                          : [...extras, item],
                      };
                    })(),
                  },
                }));
              }}
              sx={{
                position: "absolute",
                left: `${rect.left}px`,
                top: `${rect.top}px`,
                width: `${Math.max(rect.width, 4)}px`,
                height: `${Math.max(rect.height, 8)}px`,
                backgroundColor: isSelected
                  ? "rgba(156, 39, 176, 0.14)"
                  : highlightFields && textSelectionMode
                    ? "rgba(33, 150, 243, 0.05)"
                    : "transparent",
                outline: isSelected ? "1px dashed #9c27b0" : "none",
                cursor:
                  textSelectionMode && selectToolActive ? "pointer" : "default",
                zIndex: isSelected ? 31 : 12,
              }}
            />

            {existingEdit?.action === "delete" && (
              <Box
                sx={{
                  position: "absolute",
                  left: `${rect.left}px`,
                  top: `${rect.top}px`,
                  width: `${Math.max(rect.width, 4)}px`,
                  height: `${Math.max(rect.height, 8)}px`,
                  backgroundColor: "rgba(255,255,255,0.96)",
                  border: "1px dashed rgba(211, 47, 47, 0.8)",
                  zIndex: 33,
                  pointerEvents: "none",
                }}
              />
            )}

            {existingEdit?.action !== "delete" && existingEdit?.new_text
              ? (() => {
                  const editedRect = pdfRectToCanvasRect(
                    existingEdit.rect,
                    viewport || pageHeight,
                    1,
                  );

                  return (
                    <Box
                      sx={{
                        position: "absolute",
                        left: `${editedRect.left}px`,
                        top: `${editedRect.top}px`,
                        minWidth: `${Math.max(editedRect.width, 8)}px`,
                        minHeight: `${Math.max(editedRect.height, 10)}px`,
                        backgroundColor: "rgba(255,255,255,0.96)",
                        color: "#111",
                        fontSize: "12px",
                        lineHeight: 1.2,
                        padding: "1px 2px",
                        zIndex: 34,
                        pointerEvents: "none",
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {existingEdit.new_text}
                    </Box>
                  );
                })()
              : null}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default PdfTextOverlayLayer;
